// Evidência por grau — canal de drenagem (L1…). Drenagem superficial usa itemKey próprio.
// Espelha `gradeEvidenceOccurrenceKey` do catálogo do back (OCCURRENCE_KEY_PATTERN, máx. 16).

export const GRADED_LINE_FIELDS = ["cleaningState", "structuralCondition"] as const;

const GRADE_ANOMALIES = new Set(["regular", "deficient"]);

export const gradeObservationKey = (field: string) => `${field}Observations`;

export const isAnomalousGradeValue = (value: string | undefined) =>
  Boolean(value && GRADE_ANOMALIES.has(value));

/** `occurrenceKey` do Y=10 para a foto daquele grau (máx. 16 caracteres). */
export const gradeEvidenceOccurrenceKey = (
  occurrenceKey: string,
  field: string,
): string => {
  const suffix =
    field === "structuralCondition"
      ? occurrenceKey
        ? "struct"
        : "structCond"
      : field === "cleaningState"
        ? occurrenceKey
          ? "clean"
          : "cleaningState"
        : field.slice(0, 8);

  if (!occurrenceKey) return suffix;
  return `${occurrenceKey}_${suffix}`.slice(0, 16);
};

export const anomalousGradeFieldsFromAnswer = (
  answer: Record<string, unknown> | null | undefined,
): string[] => {
  if (!answer) return [];
  return GRADED_LINE_FIELDS.filter((field) => {
    const value = answer[field];
    return typeof value === "string" && isAnomalousGradeValue(value);
  });
};

export const readGradeObservation = (
  answer: Record<string, unknown> | null | undefined,
  field: string,
): string => {
  const raw = answer?.[gradeObservationKey(field)];
  return typeof raw === "string" ? raw.trim() : "";
};
